module.exports = __webpack_public_path__ + "img/VPS-foods.ab09b52.jpg";